export default __webpack_public_path__ + "static/media/entertainment.dcd596b9.jpg";